export const normalizeInstructorEmail = (email) => String(email || '').trim().toLowerCase();

export const buildNewInstructorProfileDefaults = ({
  email,
  nowMs = Date.now(),
} = {}) => ({
  Email: normalizeInstructorEmail(email),
  Role: 'Instructor',
  AccountStatus: 'Active',
  AccountCreationDate: nowMs,
  PortalAccountCreatedAt: nowMs,
  PortalLastLoginAt: nowMs,
});

export const buildInstructorPortalAccountLinkUpdate = ({
  authUser,
  existingUserData = {},
  nowMs = Date.now(),
} = {}) => {
  const update = {
    Email: normalizeInstructorEmail(authUser?.email || existingUserData?.Email),
    FirebaseAuthUID: authUser?.uid || '',
    PortalAccountCreatedAt: existingUserData.PortalAccountCreatedAt || nowMs,
    PortalLastLoginAt: nowMs,
  };

  if (!existingUserData.Role) update.Role = 'Instructor';
  if (!existingUserData.AccountStatus) update.AccountStatus = 'Active';

  return update;
};

export const buildMigratedInstructorProfileData = ({
  authUser,
  oldInstructorId,
  existingUserData = {},
  nowMs = Date.now(),
} = {}) => {
  const { LocalizedEmail, ...profileData } = existingUserData;

  const migratedProfile = {
    ...profileData,
    Email: normalizeInstructorEmail(authUser?.email || existingUserData.Email),
    FirebaseAuthUID: authUser?.uid || '',
    PreviousInstructorID: oldInstructorId || '',
    PortalAccountCreatedAt: existingUserData.PortalAccountCreatedAt || nowMs,
    PortalLastLoginAt: nowMs,
  };

  if (!migratedProfile.Role) migratedProfile.Role = 'Instructor';
  if (!migratedProfile.AccountStatus) migratedProfile.AccountStatus = 'Active';

  return migratedProfile;
};

export const canMigrateAssignedInstructorClasses = ({
  oldInstructorId,
  newInstructorId,
} = {}) => {
  const oldId = String(oldInstructorId || '').trim();
  const newId = String(newInstructorId || '').trim();

  return Boolean(oldId && newId && oldId !== newId);
};

const getBrowserMetadata = () => ({
  userAgent: typeof window !== 'undefined' ? window.navigator?.userAgent || '' : '',
  timezone: typeof Intl !== 'undefined'
    ? Intl.DateTimeFormat().resolvedOptions().timeZone || ''
    : '',
  route: typeof window !== 'undefined'
    ? window.location?.hash || window.location?.pathname || ''
    : '',
});

export const buildInstructorLoginActivity = ({
  authUser,
  userDocId,
  authProvider = 'unknown',
  nowMs = Date.now(),
  userAgent,
  timezone,
  route,
} = {}) => {
  const email = normalizeInstructorEmail(authUser?.email);
  const browserMetadata = getBrowserMetadata();

  return {
    type: 'login',
    title: 'Instructor Portal Login',
    body: `${email} signed into the instructor portal.`,
    timestamp: nowMs,
    actor: {
      uid: authUser?.uid || null,
      userDocId: userDocId || null,
      email,
    },
    metadata: {
      authProvider,
      userAgent: userAgent ?? browserMetadata.userAgent,
      timezone: timezone ?? browserMetadata.timezone,
      route: route ?? browserMetadata.route,
    },
  };
};

export const buildInstructorAccountCreationActivity = ({
  authUser,
  userDocId,
  nowMs = Date.now(),
} = {}) => {
  const email = normalizeInstructorEmail(authUser?.email);

  return {
    type: 'portal_account_created',
    title: 'Instructor Portal Account Created',
    body: `${email} created instructor portal access.`,
    timestamp: nowMs,
    actor: {
      uid: authUser?.uid || null,
      userDocId: userDocId || null,
      email,
    },
    metadata: {
      authProvider: 'password',
    },
  };
};
